import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import _ from "lodash";
import { XMarkIcon } from "@heroicons/react/20/solid";
import { UserPlusIcon } from "../../common/icons/Solid";
import { Actions as ADVISORACTIONS } from "../../../store/actions/advisorActions";
import Spinner from "../../common/Spinner";
import { useForm, Controller } from "react-hook-form";
import { v4 as uuidv4 } from "uuid";
import cleanDeep from "clean-deep";
import Select from "react-select";
import * as yup from "yup";
import NotificationManager from "react-notifications/lib/NotificationManager";

const NewAdvisorModal = ({ isModalOpen, closeModal, createAdvisor, creating, jurisdictionOptions }) => {
	const [email, setEmail] = useState("");

	const { handleSubmit, register, watch, control } = useForm();

	const jurisdiction = watch("jurisdiction", "MT");

	let emailSchema = yup.object().shape({
		email: yup.string().required().email(),
	});

	if (!isModalOpen) return null;

	const onSubmit = (data) => {
		const dataToSubmit = cleanDeep({
			id: uuidv4(),
			jurisdiction,
			...data,
		});

		emailSchema
			.isValid({
				email,
			})
			.then((valid) => {
				if (valid) {
					dataToSubmit.email = email;
					createAdvisor(dataToSubmit);
				} else {
					NotificationManager.error("Email is invalid, please check your input", "Inviting Manager");
				}
			});
	};

	return (
		<div
			className="modal"
			tabIndex="-1"
			role="dialog"
			aria-hidden="true"
			style={{ display: "block", background: "rgba(0,0,0,0.4)", overflow: "auto" }}
		>
			<div
				className="modal-dialog"
				style={{ width: "50%" }}
			>
				<div className="modal-content">
					<div
						className="block block-themed block-transparent remove-margin-b"
						style={{ padding: 0 }}
					>
						<div
							className="block-header bg-primary-dark"
							style={{ padding: 20, position: "sticky", top: 0, zIndex: 50 }}
						>
							<ul className="block-options">
								<li>
									<button
										type="button"
										onClick={closeModal}
									>
										<XMarkIcon className="h-6 w-6 mr-3 text-white" />
									</button>
								</li>
							</ul>
							<h3 className="block-title">Create New Advisor</h3>
						</div>
					</div>
					<div
						className="block-content"
						style={{ padding: 20 }}
					>
						<form onSubmit={handleSubmit(onSubmit)}>
							<div
								className="col-lg-8 col-xs-12 form-section right pl-0"
								style={{ marginTop: 10, marginRight: 10 }}
							>
								<div className="form-container col-xs-12">
									<div className="form-material form-container">
										<input
											id="name"
											className="form-control form-input"
											type="text"
											name="name"
											required="required"
											aria-required="true"
											ref={register}
										/>
										<label htmlFor="material-text">Advisor Name</label>
									</div>

									<div className="form-group">
										<div className="col-xs-4 pl-0">
											<div className="form-material form-container">
												<input
													className="form-control form-input"
													type="text"
													autoComplete="off"
													name="address[number]"
													ref={register}
												/>
												<label htmlFor="material-text">Door Number/Name</label>
											</div>
										</div>

										<div className="col-xs-8 pl-0">
											<div className="form-material form-container">
												<input
													className="form-control form-input"
													type="text"
													name="address[street]"
													autoComplete="off"
													ref={register}
												/>
												<label htmlFor="material-text">Street</label>
											</div>
										</div>

										<div className="col-xs-4 pl-0">
											<div className="form-material form-container">
												<input
													className="form-control form-input"
													type="text"
													name="address[city]"
													autoComplete="off"
													ref={register}
												/>
												<label htmlFor="material-text">City</label>
											</div>
										</div>

										{jurisdiction == "UK" && (
											<div className="col-xs-4 pl-0">
												<div className="form-material form-container">
													<input
														className="form-control form-input"
														type="text"
														name="address[county]"
														autoComplete="off"
														ref={register}
													/>
													<label htmlFor="material-text">County</label>
												</div>
											</div>
										)}

										<div className="col-xs-4 pl-0">
											<div className="form-material form-container">
												<input
													className="form-control form-input"
													type="text"
													name="address[postalCode]"
													autoComplete="off"
													ref={register}
												/>
												<label htmlFor="material-text">Postcode</label>
											</div>
										</div>
										<div className="clearfix" />
										<div className="col-xs-4 pl-0">
											<div className="form-material form-container">
												<input
													className="form-control form-input"
													type="text"
													name="vatNumber"
													autoComplete="off"
													ref={register}
												/>
												<label htmlFor="material-text">VAT</label>
											</div>
											<div className="clearfix" />
										</div>
										<div className="col-xs-4 pl-0">
											<div className="form-material form-container">
												<input
													className="form-control form-input"
													type="text"
													name="contactNumber"
													autoComplete="off"
													ref={register}
												/>
												<label htmlFor="material-text">Contact Number</label>
											</div>
										</div>
									</div>
								</div>
							</div>

							<div
								className="col-lg-4 col-xs-12 left form-section"
								style={{ marginLeft: 0, marginTop: 10 }}
							>
								<div className="col-xs-12">
									<h4>Payroll Jurisdiction</h4>
								</div>
								<div className="col-xs-12 form-container">
									<div className="form-material">
										<Controller
											as={Select}
											control={control}
											options={jurisdictionOptions}
											valueName="selected"
											value={jurisdictionOptions.find((i) => i.value == jurisdiction)}
											name="jurisdiction"
											onChange={([selected]) => {
												return selected.value;
											}}
										/>
									</div>
								</div>
							</div>

							<div
								className="col-lg-4 col-xs-12 left form-section"
								style={{ marginLeft: 0, marginTop: 0 }}
							>
								<div className="col-xs-12">
									<h4>Owner Details</h4>
								</div>
								<div
									className="col-xs-12 form-container"
									style={{ marginTop: 5 }}
								>
									<label htmlFor="email">Email</label>
									<input
										className="form-control form-input"
										value={email}
										id="email"
										type="email"
										required="required"
										onChange={(e) => {
											setEmail(e.target.value.replace(/\s/g, ""));
										}}
										autoComplete="off"
									/>
								</div>
							</div>
							<div className="clearfix" />
							<button
								className="btn btn-success right"
								type="submit"
								style={{ marginTop: 20 }}
							>
								{creating ? (
									<Spinner
										style={{ height: "1.5em", verticalAlign: "middle", float: "left" }}
										className="animate-spin -ml-1 mr-3 h-5 w-5 "
									/>
								) : (
									<UserPlusIcon style={{ height: "1.5em", float: "left" }} />
								)}
								<div style={{ float: "left", paddingLeft: 5 }}>
									{creating ? "Creating" : "Create Advisor"}
								</div>
							</button>
						</form>
						<div className="clearfix" />
					</div>
				</div>
			</div>
		</div>
	);
};

const mapStateToProps = (state, ownProps) => {
	return {
		isModalOpen: state?.advisors?.createAdvisorModal,
		creating: state?.advisors?.creatingNew,
		jurisdictionOptions: (state.jurisdictions || [])?.map(({ countryCode, name }) => ({
			label: `${name}/${countryCode}`,
			value: countryCode,
		})),
	};
};

const mapDispatchToProps = (dispatch) => ({
	closeModal: () => dispatch(ADVISORACTIONS.createAdvisorModal(false)),
	createAdvisor: (advisor) => dispatch(ADVISORACTIONS.createAdvisor(advisor)),
});

export default connect(mapStateToProps, mapDispatchToProps)(NewAdvisorModal);
